import styled from "styled-components"

import ArgentLogoSvg from "../Svgs/ArgentLogo"

export const ArgentLogo = styled(ArgentLogoSvg)`
  height: clamp(32px, 5vh, 48px);
`

export const Anchor = styled.a`
  text-decoration: none;
`
